import { render, staticRenderFns } from "./MailboxMessageHeader.vue?vue&type=template&id=fe797a30&scoped=true"
import script from "./MailboxMessageHeader.vue?vue&type=script&lang=js"
export * from "./MailboxMessageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe797a30",
  null
  
)

export default component.exports